<!-- Have temporarily commented out retry dispatcher -->
<script lang="ts">
  // import { createEventDispatcher } from 'svelte';
  import { endEvent, gameScore } from '../stores';

  // const dispatch = createEventDispatcher();

  // function retry() {
  //   gameScore.set({ score: 0, time: 0 });
  //   dispatch('retry');
  // }

  function getTime() {
    try {
      return $gameScore.time.toFixed(2);
    } catch (e) {
      return $gameScore.time;
    }
  }

  function quit() {
    console.log('sending quit event', $endEvent);
    window.parent.postMessage($endEvent, '*');
  }
</script>

<div class="modal-wrapper">
  <div class="modal-inner-wrapper">
    <div class="title">Game Over</div>

    <div class="content-wrapper mt4">
      <div class="result">
        <p>{$gameScore.score}</p>
        Score
      </div>
      <div class="result">
        <p>{getTime()}</p>
        Time
      </div>
    </div>

    <div class="buttons-wrapper mt4">
      <!-- <div on:click={retry}>Retry</div> -->
      <div on:click={quit}>Close</div>
    </div>
  </div>
</div>

<style>
  .modal-wrapper {
    /* border: 1px solid red; */
    background-color: rgba(0, 0, 0, 0.75);
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    z-index: 3999;
  }
  .modal-inner-wrapper {
    background-color: #ffc107; /* MTN Yellow */
    border-radius: 5px;
    color: black;
    width: 40rem;
    z-index: 4000;
  }

  .title {
    /* border:1px solid red; */
    font-size: x-large;
    font-weight: bold;
    margin: 2rem;
  }
  .content-wrapper {
    /* border:1px solid red; */
    display: flex;
    font-weight: bold;
    justify-content: space-evenly;
    margin: auto 3rem;
  }
  .result {
    /* border:1px solid red; */
    width: 50%;
  }
  .result:last-child {
    border-left: 1px solid black;
  }
  .result p {
    font-size: 3rem;
    font-weight: 500;
    margin: 1rem;
  }

  .buttons-wrapper {
    /* border:1px solid red; */
    display: flex;
    font-weight: bold;
    justify-content: space-evenly;
    margin: 2rem;
  }
  .buttons-wrapper div {
    background-color: #000;
    text-transform: uppercase;
    border-radius: 30px;
    padding: 5px 20px;
    color: #fff;
    cursor: pointer;
  }
</style>
